const route = {
  path: '/',
  name: '登录',
  component: () => import('../views/login/login'),
  meta: {
    title: '优安智管血糖管理系统-登录'
  }
}

export default route



// WEBPACK FOOTER //
// ./src/router/loginRouter.js